
define('text!presentation/common/toggleSwitch/views/toggleSwitch.html',[],function () { return '<div class="toggle-switch">\n    <div data-bind="css: switchStyle, click: toggleSwitch"><span></span></div>\n    <input type="checkbox" data-bind="visible: false, checked: isChecked, enable: isEnabled" />\n</div>';});

